import { Button, Col, Form, Input, Row, Space } from 'antd';
import PasswordValidator from 'password-validator';
interface ResetPasswordComponentProps {
  isCurrentPasswordIncluded?: boolean;
  onFinish: (newPassword: string) => void;
  goBack?: () => void;
}
function ResetPasswordComponent({
  isCurrentPasswordIncluded,
  onFinish,
  goBack,
}: ResetPasswordComponentProps) {
  const [form] = Form.useForm();

  const validatePassword = (value: string) => {
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8)
      .is()
      .max(20)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    if (!value) {
      return Promise.reject(new Error('비밀번호는 필수 항목입니다.'));
    }

    if (!schema.validate(value)) {
      return Promise.reject(
        new Error(
          // '영문 대 소문자, 숫자, 특수문자를 조합한 8자 이상이어야 합니다.',
          '영문 대 소문자, 숫자를 조합한 8자 이상이어야 합니다.',
        ),
      );
    }
    return Promise.resolve();
  };

  const validatePassword2 = (value: string) => {
    if (
      form.getFieldValue('newPassword') &&
      form.getFieldValue('newPassword') !== value
    ) {
      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
    }
    return Promise.resolve();
  };

  return (
    <div>
      <Row justify="center" style={{ marginTop: '70px' }}>
        <Col span={12}>
          <h1>비밀번호 변경</h1>
          <h3>비밀번호 입력 후 확인 버튼을 누르세요.</h3>
        </Col>
      </Row>
      <Row justify="center" style={{ marginBottom: '20px' }}>
        <Col span={12}>
          <Form layout="vertical" form={form} onFinish={onFinish}>
            {isCurrentPasswordIncluded && (
              <Form.Item
                name="currentPassword"
                label="현재 비밀번호"
                validateFirst={true}
                rules={[
                  {
                    required: true,
                    message: '현재 비밀번호를 입력하세요.',
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            )}
            <Form.Item
              name="newPassword"
              label="새 비밀번호"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '새 비밀번호를 입력하세요.',
                },
                {
                  validator: (_, value) => validatePassword(value),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="newPassword2"
              label="새 비밀번호 확인"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '새 비밀번호를 입력하세요.',
                },
                {
                  validator: (_, value) => validatePassword2(value),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Row justify="center">
                <Space>
                  <Button onClick={goBack}>뒤로</Button>
                  <Button htmlType="submit" type="primary">
                    확인
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
export default ResetPasswordComponent;
